<!-- Header Section -->
<div class="orders-header">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-8">
        <h2 class="page-title">
          <i class="fas fa-shopping-bag"></i>
          Mis Pedidos
        </h2>
        <p class="page-subtitle">
          Historial completo de tus compras y descargas
        </p>
      </div>
      <div class="col-lg-4 text-right">
        <div class="summary-card">
          <span class="summary-number" *ngIf="!isLoadingPedidos">{{
            listaPedidos.response.list.length
          }}</span>
          <span class="summary-number" *ngIf="isLoadingPedidos">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          <span class="summary-label">Pedidos realizados</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main Content -->
<div class="orders-content">
  <div class="container">
    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoadingPedidos">
      <div class="loading-icon">
        <i class="fas fa-spinner fa-spin fa-3x"></i>
      </div>
      <h3>Cargando pedidos...</h3>
      <p>Por favor espere mientras obtenemos su historial de compras.</p>
    </div>

    <!-- Orders Grid -->
    <div class="orders-grid" *ngIf="!isLoadingPedidos && listaPedidos.response.list.length > 0">
      <div
        class="order-card"
        [class.expanded]="isOrderExpanded(pedido.id)"
        *ngFor="
          let pedido of listaPedidos.response.list
            | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize
        "
      >
        <div
          class="order-card-header"
          (click)="toggleOrderCollapse(pedido.id, $event)"
        >
          <div class="order-number">
            <i
              [class]="
                isOrderExpanded(pedido.id)
                  ? 'fas fa-chevron-up'
                  : 'fas fa-chevron-down'
              "
            ></i>
            <span>Orden #{{ pedido.number }}</span>
          </div>

          <div class="order-summary">
            <span class="summary-item">
              <i class="far fa-calendar-alt"></i>
              {{ pedido.date }}
            </span>
            <span class="summary-item">
              <i class="fas fa-cubes"></i>
              {{ pedido.quantity }} items
            </span>
            <span class="summary-item total-price">
              <i class="fas fa-money-bill-wave"></i>
              {{ getCurrencySymbol(pedido.currency) }} {{ pedido.total }}
            </span>
          </div>

          <div
            class="order-status"
            [ngClass]="getStatusClass(pedido.stateName)"
          >
            <i [class]="getStatusIcon(pedido.stateName)"></i>
            <span>{{ pedido.stateName }}</span>
          </div>
        </div>

        <!-- Tabla de productos colapsable -->
        <div class="order-card-products" *ngIf="isOrderExpanded(pedido.id)">
          <div class="products-table-container">
            <div class="products-label">
              <i class="fas fa-box"></i>
              Productos del Pedido
            </div>

            <!-- Mostrar loader mientras se cargan los detalles -->
            <div *ngIf="getOrderProductsWithDetails(pedido.id).length === 0" class="loading-products">
              <i class="fas fa-spinner fa-spin"></i>
              <span>Cargando detalles de productos...</span>
            </div>

            <!-- Mostrar tabla cuando los detalles estén cargados -->
            <table class="products-table" *ngIf="getOrderProductsWithDetails(pedido.id).length > 0">
              <thead>
                <tr>
                  <th class="col-number">#</th>
                  <th class="col-title">Título del Producto</th>
                  <th class="col-status">Estado</th>
                  <th class="col-date">Fecha de Descarga</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let product of getOrderProductsWithDetails(pedido.id); let i = index">
                  <td class="col-number">{{ i + 1 }}</td>
                  <td class="col-title">{{ product.bookTitle }}</td>
                  <td class="col-status">
                    <span
                      class="status-text"
                      [ngClass]="{
                        'status-downloaded': getProductDownloadStatusByProduct(product) === 'downloaded',
                        'status-available': getProductDownloadStatusByProduct(product) === 'available',
                        'status-unavailable': getProductDownloadStatusByProduct(product) === 'unavailable'
                      }"
                    >
                      <i
                        [class]="
                          getProductDownloadStatusByProduct(product) === 'downloaded' ? 'fas fa-check-circle' :
                          getProductDownloadStatusByProduct(product) === 'available' ? 'fas fa-circle' :
                          'fas fa-times-circle'
                        "
                      ></i>
                      {{
                        getProductDownloadStatusByProduct(product) === 'downloaded' ? 'Descargado' :
                        getProductDownloadStatusByProduct(product) === 'available' ? 'Disponible' :
                        'No disponible'
                      }}
                    </span>
                  </td>
                  <td class="col-date">
                    <span class="download-date">
                      {{ getProductDownloadDateByProduct(product) || '-' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          class="order-card-footer"
          (click)="toggleOrderCollapse(pedido.id, $event)"
        >
          <div class="footer-text">
            <i class="fas fa-info-circle"></i>
            <span>Haz clic en "Ver detalles" para ver las imágenes y descargar los archivos</span>
          </div>
          <button
            class="btn-view-details"
            (click)="
              frame.show();
              obtenerDatosPedidoConUrl(pedido.id, pedido.number);
              $event.stopPropagation()
            "
          >
            <i class="fas fa-images"></i>
            Ver detalles
          </button>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoadingPedidos && listaPedidos?.response?.list?.length === 0">
      <div class="empty-icon">
        <i class="fas fa-shopping-bag"></i>
      </div>
      <h3>No tienes pedidos aún</h3>
      <p>
        Cuando realices tu primera compra, aparecerá aquí tu historial de
        pedidos.
      </p>
      <a routerLink="/" class="btn btn-primary" style="    background-color: #bb2125 !important;
    color: white;">
        <i class="fas fa-search"></i>
        Explorar Catálogo
      </a>
    </div>

    <!-- Pagination -->
    <div
      class="pagination-wrapper"
      *ngIf="listaPedidos.response.list.length > pageSize"
    >
      <ngb-pagination
        [maxSize]="5"
        [(page)]="page"
        class="modern-pagination"
        [pageSize]="pageSize"
        [boundaryLinks]="true"
        [collectionSize]="listaPedidos.response.list.length"
      >
      </ngb-pagination>
    </div>
  </div>
</div>

<!-- Modal de Detalles -->
<div
  mdbModal
  #frame="mdbModal"
  class="modal fade"
  id="frameModalTop"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
    <div class="modal-content modern-modal">
      <!-- Modal Header -->
      <div class="modal-header">
        <div class="header-content">
          <h4 class="modal-title">
            <i class="fas fa-receipt"></i>
            Detalle del Pedido #{{ orderCabeceraResponse.response.list[0]?.number }}
          </h4>
          <div class="quick-summary" *ngIf="orderCabeceraResponse.response.list[0]">
            <span class="quick-item">
              <i class="far fa-calendar-alt"></i>
              {{ formatTransactionDate(orderCabeceraResponse.response.list[0].transactiondate) }}
            </span>
            <span class="quick-item">
              <i class="fas fa-cubes"></i>
              {{ pedidoDetalle.response.list.length }} producto(s)
            </span>
            <span class="quick-item total-highlight">
              <i class="fas fa-money-bill-wave"></i>
              {{ getCurrencySymbol(orderCabeceraResponse.response.list[0].currency) }} {{ orderCabeceraResponse.response.list[0].total }}
            </span>
          </div>
        </div>
        <button
          type="button"
          class="close"
          style="right: 25px !important"
          (click)="frame.hide()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div class="container-fluid">
          <!-- Products Section -->
          <div class="detail-section">
            <div class="section-header">
              <h5>
                <i class="fas fa-box-open"></i>
                Productos Adquiridos
              </h5>
            </div>

            <div class="products-grid">
              <div
                class="product-item"
                *ngFor="let pedidos of pedidoDetalle.response.list; let i = index"
              >
                <div class="product-image">
                  <img
                    *ngIf="getProductImage(pedidos.orderDetailId)"
                    [src]="getProductImage(pedidos.orderDetailId)"
                    alt="Imagen del producto"
                    class="product-img"
                  />
                </div>

<div class="product-info">
  <h6 class="product-title">
    <span class="product-index">Producto #{{ i + 1 }}:</span> {{ pedidos.bookTitle }}
  </h6>
  <div class="product-details">
    <span class="product-modality" *ngIf="pedidos.bookModalidadName">
      <i class="fas fa-tag"></i>
      {{ getModalidadFullName(pedidos.bookModalidadName) }}
    </span>
    <span class="product-quantity">
      <i class="fas fa-cubes"></i>
      Cantidad: {{ pedidos.orderDetailQuantity }}
    </span>
    <span class="product-price">
      <i class="fas fa-money-bill-wave"></i>
      {{ getCurrencySymbol(orderCabeceraResponse.response.list[0].currency) }} {{ pedidos.bookPrice }}
    </span>
  </div>
</div>

<div class="product-actions">
  <!-- Botón de descarga activo -->
  <button
    *ngIf="pedidos.codeOrderDetailId != '' && pedidos.flagDownload != '1'"
    class="btn-download"
    [class.btn-downloading]="isDownloading(pedidos.codeOrderDetailId)"
    [disabled]="isDownloading(pedidos.codeOrderDetailId)"
    (click)="mostrarModalConfirmacion(pedidos.codeOrderDetailId, pedidos.bookTitle)"
    aria-label="Descargar {{ pedidos.bookTitle }}"
  >
    <i *ngIf="!isDownloading(pedidos.codeOrderDetailId)" class="fas fa-download"></i>
    <i *ngIf="isDownloading(pedidos.codeOrderDetailId)" class="fas fa-spinner fa-spin"></i>
    {{ isDownloading(pedidos.codeOrderDetailId) ? 'Descargando...' : 'Descargar' }}
  </button>

  <!-- Botón descargado con fecha debajo -->
  <div *ngIf="pedidos.flagDownload == '1'" class="downloaded-block">
    <button
      class="btn-download btn-completed"
      disabled
      aria-label="Archivo descargado"
    >
      <i class="fas fa-check-circle"></i>
      <span>Descargado</span>
    </button>
    <span
      *ngIf="pedidos.dateDownload"
      class="download-date-inline"
    >
      <i class="fas fa-clock"></i> {{ pedidos.dateDownload }}
    </span>
  </div>

  <!-- No disponible -->
  <span *ngIf="pedidos.codeOrderDetailId == ''" class="download-unavailable">
    <i class="fas fa-lock"></i>
    No disponible
  </span>
</div>


                
              </div>
            </div>
          </div>

          <!-- Purchase Summary Section -->
          <div class="detail-section">
            <div class="section-header">
              <h5>
                <i class="fas fa-file-invoice-dollar"></i>
                Resumen de Compra
              </h5>
            </div>

            <div class="summary-grid">
              <div class="summary-item">
                <span class="summary-label">
                  <i class="fas fa-hashtag"></i>
                  Orden de Compra
                </span>
                <span class="summary-value">
                  N° {{ orderCabeceraResponse.response.list[0].number }}
                </span>
              </div>

              <div class="summary-item total-highlight">
                <span class="summary-label">
                  <i class="fas fa-calculator"></i>
                  Total Final
                </span>
                <span class="summary-value">
                  {{ getCurrencySymbol(orderCabeceraResponse.response.list[0].currency) }} {{ orderCabeceraResponse.response.list[0].total }}
                </span>
              </div>

              <div class="summary-item">
                <span class="summary-label">
                  <i class="fas fa-coins"></i>
                  Moneda
                </span>
                <span class="summary-value">
                  {{ orderCabeceraResponse.response.list[0].currency }}
                </span>
              </div>

              <div class="summary-item">
                <span class="summary-label">
                  <i class="fas fa-calendar"></i>
                  Fecha de Transacción
                </span>
                <span class="summary-value">
                  {{
                    formatTransactionDate(
                      orderCabeceraResponse.response.list[0].transactiondate
                    )
                  }}
                </span>
              </div>

              <div class="summary-item">
                <span class="summary-label">
                  <i class="fas fa-fingerprint"></i>
                  ID de Transacción
                </span>
                <span class="summary-value">
                  {{ orderCabeceraResponse.response.list[0].transactionid }}
                </span>
              </div>

              <div class="summary-item">
                <span class="summary-label">
                  <i class="fas fa-credit-card"></i>
                  Tipo de Tarjeta
                </span>
                <span class="summary-value">
                  {{ orderCabeceraResponse.response.list[0].brand | uppercase }}
                </span>
              </div>

              <div class="summary-item">
                <span class="summary-label">
                  <i class="fas fa-mask"></i>
                  Tarjeta Enmascarada
                </span>
                <span class="summary-value">
                  {{ orderCabeceraResponse.response.list[0].card }}
                </span>
              </div>

              <div class="summary-item">
                <span class="summary-label">
                  <i class="fas fa-info-circle"></i>
                  Estado
                </span>
                <span
                  class="summary-value"
                  [ngClass]="
                    getStatusClass(
                      orderCabeceraResponse.response.list[0].stateName
                    )
                  "
                >
                  {{ orderCabeceraResponse.response.list[0].stateName }}
                </span>
              </div>

              <div
                class="summary-item"
                *ngIf="
                  orderCabeceraResponse.response.list[0].stateId.toString() !=
                  '24'
                "
              >
                <span class="summary-label">
                  <i class="fas fa-ticket-alt"></i>
                  Número de Voucher
                </span>
                <span class="summary-value">
                  {{ orderCabeceraResponse.response.list[0].voucherNro }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="frame.hide()">
          <i class="fas fa-times"></i>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Overlay personalizado para modal de confirmación -->
<div class="custom-confirm-overlay" *ngIf="showConfirmOverlay" (click)="cerrarModalConfirmacion()"></div>

<!-- Modal de Confirmación de Descarga -->
<div
  mdbModal
  #confirmModal="mdbModal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content modern-modal-confirm">
      <!-- Modal Header -->
      <div class="modal-header modal-header-warning">
        <h4 class="modal-title" id="confirmModalLabel">
          <i class="fas fa-exclamation-triangle"></i>
          Confirmar Descarga
        </h4>
        <button
          type="button"
          class="close"
          (click)="cerrarModalConfirmacion()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <div class="warning-content">
          <div class="warning-icon">
            <i class="fas fa-info-circle"></i>
          </div>
          <div class="warning-text">
            <h5>¿Estás seguro de descargar este archivo?</h5>
            <p class="product-name-confirm">
              <strong>{{ selectedProductTitle }}</strong>
            </p>
            <div class="alert alert-warning">
              <i class="fas fa-exclamation-circle"></i>
              <strong>Importante:</strong> Una vez que guardes el archivo en tu computadora:
              <ul>
                <li>El botón de descarga se <strong>bloqueará permanentemente</strong></li>
                <li><strong>No podrás descargar</strong> este archivo nuevamente</li>
                <li>Asegúrate de guardar el archivo en una ubicación segura</li>
              </ul>
            </div>
            <p class="confirm-question">
              Si cancelas la descarga después de iniciarla, el botón igualmente se bloqueará.
              ¿Deseas continuar con la descarga?
            </p>
          </div>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="cerrarModalConfirmacion()"
        >
          <i class="fas fa-times"></i>
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="confirmarDescarga()"
        >
          <i class="fas fa-download"></i>
          Sí, Descargar Archivo
        </button>
      </div>
    </div>
  </div>
</div>
